import { faker } from '@faker-js/faker';

import type { AccountTypePostResponse } from '../types/AccountTypePostResponse';

export function createAccountTypePostResponse(
  data: NonNullable<Partial<AccountTypePostResponse>> = {}
): NonNullable<AccountTypePostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
